import React from "react";
import {
  SkeletonFeatured,
  SkeletonGrid,
  SkeletonCard,
} from "./Members.styles";

const MemberFeedSkeleton = ({ showLead = true }) => (
  <>
    {showLead && <SkeletonFeatured aria-hidden="true" />}
    <SkeletonGrid $noFeatured={!showLead}>
      <SkeletonCard aria-hidden="true" />
      <SkeletonCard aria-hidden="true" />
      <SkeletonCard aria-hidden="true" />
      <SkeletonCard aria-hidden="true" />
      {!showLead && (
        <>
          <SkeletonCard aria-hidden="true" />
          <SkeletonCard aria-hidden="true" />
        </>
      )}
    </SkeletonGrid>
  </>
);

export default MemberFeedSkeleton;
